// extracted by mini-css-extract-plugin
module.exports = {"expandableSummary":"styles-module__expandableSummary___3wW7I"};